import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'

const user = {
  state: {
    user: {},
    list: [],
    active: 0,
    url: 'https://api.tongzhou666.com',
    // url: 'http://beta.tongzhou666.com',
    // url: 'http://alpha.hulelive.com',
  },

  mutations: {
    setUser(state, user) {
      state.user = { ...state.user, ...user };
    },
    setList(state, list) {
      state.list = list;
    },
    setActive(state, active) {
      state.active = active;
    },
  },

  actions: {

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js